import { createI18n } from 'vue-i18n'

import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'sl',
  fallbackLocale: 'en',
  messages: { sl, en },
  availableLocales: ['sl', 'en'],
})

export default i18n
